type BezierCoordinates = readonly [number, number, number, number];

export const easing = {
  easeOutSmooth: [0.2, 0, 0, 1],
  easeInOutBack: [0.4, 0, 0.3, 1.5],
} as const satisfies Record<string, BezierCoordinates>;

export type EasingKey = keyof typeof easing;
